var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColorModeSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0336 15.5367L13.4147 13.7683H10.5853L9.9664 15.5367H8.28647L11.1158 7.57913H12.8842L15.7135 15.5367H14.0336ZM19.0734 9.07339V4.92661H14.9266L12 2L9.07339 4.92661H4.92661V9.07339L2 12L4.92661 14.9266V19.0734H9.07339L12 22L14.9266 19.0734H19.0734V14.9266L22 12L19.0734 9.07339ZM10.9832 12.5747H13.0168L12 9.34748L10.9832 12.5747Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorModeSystem);
export default __webpack_public_path__ + "static/media/icon-color-mode-system.3a99622481e7fe6d14b3c6f0e56cdc5e.svg";
export { ForwardRef as ReactComponent };